export default function (other) {
  other = other || {}
  return {
    orgId: other.orgId || null,
    pixel: other.pixel || null,
    pixelNumber: other.pixelNumber || null,
    pixelToken: other.pixelToken || null,
    agencyName: other.agencyName || null,
    creationTime: other.creationTime || null,
  }
}
